module.exports = __webpack_public_path__ + "img/Jacob_Parhamovich.29dd5666.png";